import { render } from "./ProductAddModal.vue?vue&type=template&id=408344bb"
import script from "./ProductAddModal.vue?vue&type=script&lang=js"
export * from "./ProductAddModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__